import React, {Component} from 'react';
import {connect} from 'react-redux';
import pick from 'lodash.pick';

import {Field, formValueSelector, reduxForm} from "redux-form";
import {Collapse} from "reactstrap";
import {BoolButtonsField, InputField} from "../../../../../validation/ReduxFormInput";
import {handleSubmitAdvanced} from "../../../actions/application";

class GeneralForm extends Component {
    render() {
        const {
            initialValues,
            form_values: {
                has_pets,
                eviction,
                liquid_furniture,
                conviction,
                bankruptcy_filed
            }, handleSubmit,
        } = this.props;

        return (
            <form onSubmit={handleSubmit}>
                <Field name="is_smoker" label="Do you smoke?" inverse component={BoolButtonsField} defaultValue={initialValues.is_smoker}/>

                <Field name="has_pets" label="Do you have any pets?" inverse component={BoolButtonsField} defaultValue={initialValues.has_pets}/>
                <Collapse isOpen={!!has_pets}>
                    <Field name="pets_explanation" label="Can you give us some details about your pet(s)?" placeholder="..." component={InputField} type="textarea"/>
                </Collapse>

                <Field name="eviction" label="Have you ever been evicted?" inverse component={BoolButtonsField} defaultValue={initialValues.eviction}/>
                <Collapse isOpen={!!eviction}>
                    <Field name="eviction_explanation" label="Please explain why you were evicted" placeholder="..." component={InputField} type="textarea"/>
                </Collapse>

                <Field name="liquid_furniture" label="Do you plan to use any liquid filled furniture?" inverse component={BoolButtonsField} defaultValue={initialValues.liquid_furniture}/>
                <Collapse isOpen={!!liquid_furniture}>
                    <Field name="liquid_furniture_explanation" label="Can you elaborate?" placeholder="..." component={InputField} type="textarea"/>
                </Collapse>

                <Field name="conviction" label="Have you been convicted or plead no contest to a felony?" inverse component={BoolButtonsField} defaultValue={initialValues.conviction}/>
                <Collapse isOpen={!!conviction}>
                    <Field name="conviction_explanation" label="Tell us about it" placeholder="..." component={InputField} type="textarea"/>
                </Collapse>

                <Field name="bankruptcy_filed" label="Have you filed for bankruptcy in the past 7 years?" inverse component={BoolButtonsField} defaultValue={initialValues.bankruptcy_filed}/>
                <Collapse isOpen={!!bankruptcy_filed}>
                    <Field name="bankruptcy_filed_explanation" label="What happened?" placeholder="..." component={InputField} type="textarea"/>
                </Collapse>
            </form>
        );
    }
}

const validate = values => {
    const errors = {};

    const truthy = (val) => {
        return val !== null;
    };

    !truthy(values.is_smoker) && (errors.is_smoker = 'Required');
    !truthy(values.has_pets) && (errors.has_pets = 'Required');
    !truthy(values.eviction) && (errors.eviction = 'Required');
    !truthy(values.liquid_furniture) && (errors.liquid_furniture = 'Required');
    !truthy(values.conviction) && (errors.conviction = 'Required');
    !truthy(values.bankruptcy_filed) && (errors.bankruptcy_filed = 'Required');

    return errors;
};

const submit = (data, dispatch) => {
    return dispatch(handleSubmitAdvanced(data));
};

GeneralForm = reduxForm({
    form: 'application_general',
    onSubmit: submit,
    validate,
    enableReinitialize: true
})(GeneralForm);

const mapStateToProps = (state) => {
    const selector = formValueSelector('application_general');
    let initial = state.tenant.application.is_advanced_complete ? Object.assign({}, pick(state.tenant.application, [
            'is_smoker',
            'has_pets',
            'eviction',
            'liquid_furniture',
            'conviction',
            'bankruptcy_filed',

            'pets_explanation',
            'eviction_explanation',
            'liquid_furniture_explanation',
            'conviction_explanation',
            'bankruptcy_filed_explanation'
        ]
    )) : {};
    return {
        form_values: selector(state, 'is_smoker', 'has_pets', 'eviction', 'bankruptcy_filed', 'liquid_furniture', 'conviction'),
        is_advanced_complete: state.tenant.application.is_advanced_complete,
        initialValues: initial
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        _handleSubmitAdvanced(data) {
            return dispatch(handleSubmitAdvanced(data));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(GeneralForm);


// WEBPACK FOOTER //
// ./src/containers/tenant/application/frames/forms/GeneralForm.js